import * as yup from "yup";
import * as Yup from "yup";

export const schemaResetPassword = yup.object({
    token: yup
        .string()
        .required("Token jest wymagany"),

    password: yup
        .string()
        .required('Hasło jest wymagane')
        .min(8, 'Hasło musi mieć co najmniej 8 znaków')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
            'Hasło musi zawierać co najmniej jedną małą literę, jedną wielką literę i jedną cyfrę'
        )
        .default(""),

    confirmPassword: Yup.string()
        .required('Potwierdzenie hasła jest wymagane')
        .oneOf([Yup.ref('password')], 'Hasła muszą być identyczne')
        .default(""),
}).required();
